export function isAuthenticatedSuperAdmin() {
  const token = localStorage.getItem('token');
  const user = sessionStorage.getItem('user');
  if (!token || !user) return false;
  try {
    const parsed = JSON.parse(user);
    return parsed.role && parsed.role.is_super_admin;
  } catch {
    return false;
  }
}

export function isAuthenticatedAdmin() {
  const token = localStorage.getItem('token');
  const user = sessionStorage.getItem('user');
  console.log('isAuthenticatedAdmin - token:', !!token);
  console.log('isAuthenticatedAdmin - user:', !!user);
  if (!token || !user) return false;
  try {
    const parsed = JSON.parse(user);
    console.log('isAuthenticatedAdmin - parsed user:', parsed);
    const hasRole = parsed.role && (parsed.role.is_super_admin || parsed.role.name === 'admin');
    console.log('isAuthenticatedAdmin - hasRole:', hasRole);
    return hasRole;
  } catch (e) {
    console.log('isAuthenticatedAdmin - error:', e);
    return false;
  }
}

export function getCurrentUser() {
  const user = sessionStorage.getItem('user');
  console.log('getCurrentUser - user:', !!user);
  if (!user) return null;
  try {
    const parsed = JSON.parse(user);
    console.log('getCurrentUser - parsed:', parsed);
    return parsed;
  } catch (e) {
    console.log('getCurrentUser - error:', e);
    return null;
  }
} 